var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.1 426.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bold"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M341.3,42.7h-89.3C243.3,18,219.8,0,192,0s-51.3,17.9-60,42.7H42.7C19.1,42.7,0,61.8,0,85.4v298.7c0,23.6,19.1,42.7,42.7,42.7h298.7c23.6,0,42.7-19.1,42.7-42.7V85.4c0-23.6-19.1-42.7-42.7-42.7h-.1ZM192,42.7c11.7,0,21.3,9.5,21.3,21.3s-9.6,21.3-21.3,21.3-21.3-9.5-21.3-21.3,9.6-21.3,21.3-21.3h0ZM317,276.1H67v-40h250v40Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropTask);
export default __webpack_public_path__ + "static/media/Drop Task.92142be8c5e3da27f57a1dd039b42077.svg";
export { ForwardRef as ReactComponent };